// src/components/common/GlobalLoader.jsx
// -----------------------------------------------------------------------------
// Full-screen centered API loader overlay component.
// Reads loading visibility status from LoadingContext.
// -----------------------------------------------------------------------------
import { useLoading } from '../../context/LoadingContext';
import './common.css';

export default function GlobalLoader() {
  const { isLoading, loadingMessage } = useLoading();

  if (!isLoading) return null;

  return (
    <div className="global-loader-overlay" role="status" aria-live="polite">
      <div className="global-loader-box">
        <div className="afix-loader-spinner" />
        <span className="global-loader-text">
          {loadingMessage || 'Processing request...'}
        </span>
      </div>
    </div>
  );
}

